import DateCell from '../../../elements/Table/Cells/DateCell'
import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button } from 'antd'

function EmployeeLoanList(props) {
  const { list, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Date', accessor: 'orderDate', Cell: DateCell },
    { Header: 'Company', accessor: 'company.fn' },
    { Header: 'Employee', accessor: 'hr.fn' },
    { Header: 'Title', accessor: 'title' },
    // {Header: 'Category', accessor: 'category'},
    { Header: 'Status', accessor: 'status' },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          New{' '}
        </Button>
      )}
      columns={columns}
      defaultSorted={[
        {
          id: 'orderDate',
          desc: true,
        },
      ]}
    />
  )
}

EmployeeLoanList.propTypes = {}
EmployeeLoanList.defaultProps = {}

export default EmployeeLoanList
